var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, SvgIcon } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useQuery, useMutation, useReactiveVar } from '@apollo/client';
import { DatasourcesByOrganizationDocument, QuerySqlDocument, } from '../../../generated/graphql';
import { lastAccessedOrganizationVar } from '../../../cache';
import SelectDatasource from './SelectDatasource';
var useStyle = makeStyles({
    root: {
        display: 'flex',
        '& [class*="menu"]': {
            top: 'auto',
            width: '80%',
        },
    },
    icon: {
        flex: 1,
        height: 36,
        marginRight: 12,
    },
});
var DataSource = function (_a) {
    var setDatasourceId = _a.setDatasourceId;
    var currentOrganization = useReactiveVar(lastAccessedOrganizationVar);
    var classes = useStyle();
    var _b = useState(), options = _b[0], setOptions = _b[1];
    var _c = useState(), selected = _c[0], setSelected = _c[1];
    var _d = useQuery(DatasourcesByOrganizationDocument, {
        variables: { organizationId: currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id },
        skip: !currentOrganization,
    }), data = _d.data, loading = _d.loading, error = _d.error;
    var _e = useMutation(QuerySqlDocument), querySql = _e[0], querySqlError = _e[1].error;
    useEffect(function () {
        var _a;
        // should be able to check datasourcesByOrganization itselt instead of ".length"
        // after https://github.com/kaizenplatform/dataplatform-api-spec/pull/31
        if (data && ((_a = data.datasourcesByOrganization) === null || _a === void 0 ? void 0 : _a.length)) {
            var selectOptions = data.datasourcesByOrganization.map(function (datasource) {
                return {
                    value: datasource.id,
                    label: "" + datasource.name,
                };
            });
            setOptions(selectOptions);
            setSelected({
                value: data.datasourcesByOrganization[0].id,
                label: data.datasourcesByOrganization[0].name,
                previewTable: null,
            });
            setDatasourceId(data.datasourcesByOrganization[0].id);
        }
    }, [data]);
    var selectDatasetHandler = useCallback(function (target) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSelected(target);
            setDatasourceId(target.value);
            return [2 /*return*/];
        });
    }); }, []);
    if (loading)
        return (React.createElement(Container, { className: classes.root },
            React.createElement(DataBaseIcon, { className: classes.icon }),
            React.createElement(Skeleton, { variant: "rect", width: '100%', height: 40 })));
    if (!loading && !options)
        return (React.createElement(Container, { className: classes.root },
            React.createElement(DataBaseIcon, { className: classes.icon }),
            React.createElement(SelectDatasource, { selected: { value: '', label: 'no Datasource registered' }, selectDatasetHandler: selectDatasetHandler, options: options, isDisabled: true })));
    return (React.createElement(Container, { className: classes.root },
        React.createElement(DataBaseIcon, { className: classes.icon }),
        React.createElement(SelectDatasource, { selected: selected, selectDatasetHandler: selectDatasetHandler, options: options })));
};
var DataBaseIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M12,10C8.2,10,4.3,9.3,2,7.6V12c0,2.7,5.2,4,10,4s10-1.3,10-4V7.6C19.7,9.3,15.8,10,12,10z" }),
        React.createElement("path", { d: "M12,18c-3.8,0-7.7-0.7-10-2.4V20c0,2.7,5.2,4,10,4s10-1.3,10-4v-4.4C19.7,17.3,15.8,18,12,18z" }),
        React.createElement("path", { d: "M12,0C7.2,0,2,1.3,2,4s5.2,4,10,4s10-1.3,10-4S16.8,0,12,0z" })))); };
export default DataSource;
